import { render, staticRenderFns } from "./NewLocationCommunitySelector.vue?vue&type=template&id=460ad64e"
import script from "./NewLocationCommunitySelector.vue?vue&type=script&lang=js"
export * from "./NewLocationCommunitySelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports